export default {
      id: "yellow-bullet-usage",
      viewBox: "0 0 11.712 13.332",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#yellow-bullet",
      toString: function () {
        return this.url;
      }
    }